module.exports = __webpack_public_path__ + "img/memory_1000.9358812b.jpg";